import { combineReducers } from 'redux';
import auth from './auth';
import navigation from './navigation';
import alerts from './alerts';
import analytics from './analytics';
import users from './usersReducers';
import layout from './layout';
import dashboard from './dashboard';

const rootReducer = () =>
  combineReducers({
    alerts,
    auth,
    layout,
    navigation,
    analytics,
    users,
    dashboard,
  });

export default rootReducer;
